import {GET, POST} from "../util";

const inspectionUrl = "api/investments-receivables-inspection";
const operationUrl = "api/investments-receivables-operation";

const url = {
    inspection: {
        accounts: `${inspectionUrl}/accounts`,
        list: `${inspectionUrl}/list/:accountId`,
        downloadAllDocuments: `${inspectionUrl}/download-all-documents`,
        downloadAllCollectionDocuments: `${inspectionUrl}/download-all-collection-documents/{receivableId}`,
        exportCsv: `${inspectionUrl}/export-csv/:accountId/:fromDate/:toDate/:fileType`,
        preferences: `${inspectionUrl}/export-csv/preferences`,
        reminderLogHistory: `${inspectionUrl}/reminder-log-history/:receivableId/list`,
    },

    operation: {
        resell: `${operationUrl}/resell`,
        requestIpu: `${operationUrl}/request-ipu/:receivableId`,
    }
};
const allInvestmentsReceivablesApi = {
    inspection: {
        getAccounts: () => {
            return GET(url.inspection.accounts);
        },
        list: (accountId, params = {}) => {
            return POST(url.inspection.list.replace(":accountId", accountId), params);
        },
        downloadAllDocuments: (params = {}) => {
            return POST(url.inspection.downloadAllDocuments, params);
        },
        downloadAllCollectionDocuments: (receivableId) => {
            return GET(url.inspection.downloadAllCollectionDocuments.replace('{receivableId}', receivableId));
        },
        exportCsv: (params = {}) => {
            let exportCsvUrl = url.inspection.exportCsv
                .replace(":accountId", params.accountId)
                .replace(":fromDate", params.fromDate)
                .replace(":toDate", params.toDate)
                .replace(":fileType", params.fileType);

            return POST(exportCsvUrl, params.fieldList, "application/json", "Array", true);
        },
        preferences: () => {
            return GET(url.inspection.preferences);
        },
        reminderLogHistory: (receivableId) => {
            return GET(url.inspection.reminderLogHistory.replace(":receivableId", receivableId));
        },
    },
    operation: {
        resell: (params) => {
            return POST(url.operation.resell, params);
        },
        requestIpu: (receivableId) => {
            return POST(url.operation.requestIpu.replace(":receivableId", receivableId));
        },
    }
};
export {
    allInvestmentsReceivablesApi
};